export default __webpack_public_path__ + "static/media/add-b.a6ee33a8.svg";